// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"tcTaggingFileHistory_fileStatusContainer__36u9T","loadMoreBtnContainer":"tcTaggingFileHistory_loadMoreBtnContainer__1i-qN"};